export default __webpack_public_path__ + "static/media/playstore-badge.800c9d9f.png";